// I18N
let gettext = null;

if (typeof Gettext !== 'undefined' && Gettext !== null) {
	const _gettext = new Gettext({domain: "annotator"});
	gettext = msgid => _gettext.gettext(msgid);
}
else {
	gettext = msgid => msgid;
}

const _t = msgid => gettext(msgid);


const CorrectorUtil = {};

/*
* Flatten a nested array structure
*
* Returns an array
 */
CorrectorUtil.flatten = function(array) {
	const flatten = function(ary){
		let flat = [];
		for(const el of ary) {
			flat = flat.concat(el && $.isArray(el) ? flatten(el) : el);
		}
		return flat;
	};
	return flatten(array);
};


/*
* decides whether node A is an ancestor of node B.
*
* This function purposefully ignores the native browser function for this, because it acts weird in PhantomJS.
* Issue: https://github.com/ariya/phantomjs/issues/11479
 */
CorrectorUtil.contains = function(parent, child) {
	let node = child;
	while (node !== null) {
		if (node === parent) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
};

/*
* Finds all text nodes within the elements in the current collection.
*
* Returns a new jQuery collection of text nodes.
 */
CorrectorUtil.getTextNodes = function(jq) {
	const getTextNodes = function(node){
		let nodes;
		if (node && node.nodeType !== Node.TEXT_NODE) {
			nodes = [];
			if (node.nodeType !== Node.COMMENT_NODE) {
				node = node.lastChild;
				while (node) {
					nodes.push(getTextNodes(node));
					node = node.previousSibling;
				}
			}
			return nodes.reverse();
		}
		else {
			return node;
		}
	};
	const result = jq.map(function() {
		return CorrectorUtil.flatten(getTextNodes(this));
	});
	return result;
};

/*
* determine the last text node inside or before the given node
 */
CorrectorUtil.getLastTextNodeUpTo = function(n){
	let result;
	switch (n.nodeType) {
		case Node.TEXT_NODE:
			return n;
		case Node.ELEMENT_NODE:
			if (n.lastChild != null) {
				result = CorrectorUtil.getLastTextNodeUpTo(n.lastChild);
				if (result != null) {
					return result;
				}
			}
			break;
	}
	n = n.previousSibling;
	if (n != null) {
		return CorrectorUtil.getLastTextNodeUpTo(n);
	}
	else {
		return null;
	}
};

/*
* determine the first text node in or after the given jQuery node.
 */
CorrectorUtil.getFirstTextNodeNotBefore = function(n) {
	let result;
	switch (n.nodeType) {
		case Node.TEXT_NODE:
			return n;
		case Node.ELEMENT_NODE:
			if (n.firstChild != null) {
				result = CorrectorUtil.getFirstTextNodeNotBefore(n.firstChild);
				if (result != null) {
					return result;
				}
			}
			break;
	}
	n = n.nextSibling;
	if (n != null) {
		return CorrectorUtil.getFirstTextNodeNotBefore(n);
	}
	else {
		return null;
	}
};


/*
* read out the text value of a range using the selection API
*
* This method selects the specified range, and asks for the string value of the selection.
* What this returns is very close to what the user actually sees.
 */
CorrectorUtil.readRangeViaSelection = function(range) {
	// Get the browser selection object
	const sel = CorrectorUtil.getSelection();
	// clear the selection
	sel.removeAllRanges();
	// Select the range
	sel.addRange( range.toRange() );
	// Read out the selection
	return sel.toString();
};

CorrectorUtil.xpathFromNode = function(el, relativeRoot){
	let result;
	try {
		result = simpleXPathJQuery.call(el, relativeRoot);// TODO: check for simpleXPathJQuery
	}
	catch(exception) {
		console.log( _t("jQuery-based XPath construction failed! Falling back to manual.") );
		result = simpleXPathPure.call(el, relativeRoot); // TODO: check for simpleXPathPure
	}
	return result;
};

CorrectorUtil.nodeFromXPath = function(xp, root) {
	const steps = xp.substring(1).split("/");
	let node = root;

	for (const step of steps) {
		let parts = step.split("[");
		let name = parts[0];
		let idx = parts[1];
		if (idx !== null) {
			idx = parseInt(idx.split("]")[0], 10);
		}
		else {
			idx = 1;
		}
		node = findChild(node, name.toLowerCase(), idx);// TODO: check for findChild
	}

	return node;
};

CorrectorUtil.escape = function(html) {
	return html
		.replace(/&(?!\w+;)/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
};

CorrectorUtil.uuid = (function() {
	let counter = 0;
	return function() {
		return counter++;
	};
})();

CorrectorUtil.getGlobal = () => (function() { return this; })();

/*
* Return the maximum z-index of any element in $elements (a jQuery collection).
 */
CorrectorUtil.maxZIndex = function($elements) {
	let all = (function(){
		let _results = [];
		$elements.each(function(){
			const $el = $(this);
			if ($el.css('position') === 'static') {
				_results.push(-1);
			}
			else {
				_results.push(parseFloat($el.css('z-index')) || -1);
			}
		});
		return _results;
	})();
	return Math.max.apply(Math, all);
};

CorrectorUtil.mousePosition = function(e, offsetEl){
	// If the offset element is not a positioning root use its offset parent
	const _ref = $(offsetEl).css('position');
	if (_ref !== 'absolute' && _ref !== 'fixed' && _ref !== 'relative') {
		offsetEl = $(offsetEl).offsetParent()[0];
	}
	const offset = $(offsetEl).offset();
	return {
		top: e.pageY - offset.top,
		left: e.pageX - offset.left
	};
};

/*
* Checks to see if an event parameter is provided and contains the prevent default method. If it does it calls it.
*
* This is useful for methods that can be optionally used as callbacks where the existance of the parameter must be checked before calling.
 */
CorrectorUtil.preventEventDefault = function(event){
	if (event) {
		event.preventDefault();
	}
};


CorrectorUtil.getSelection = function() {
	if (window.getSelection) {
		return window.getSelection();
	}
	else if (document.selection) { // should come last; Opera!
		return document.selection.createRange();
	}
};
